<template>
    <main>
        <div class="min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-4">
            <div class="max-w-max mx-auto">
            <main class="sm:flex">
                <p class="text-4xl font-bold text-dgreen sm:text-5xl">{{ status }}</p>
                <div class="sm:ml-6">
                <div class="sm:border-l sm:border-gray-200 sm:pl-6">
                    <h1 class="text-4xl font-bold text-gray-900 tracking-tight sm:text-5xl">{{ title }}</h1>
                    <p class="mt-1 text-base text-gray-500">{{ description }}</p>
                </div>
                <div class="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                    <a href="/" class="button dgreen"> Terug naar homepage </a>
                    <a href="/klantenservice" class="button default"> Klantenservice </a>
                </div>
                </div>
            </main>
            </div>
        </div>

        <!-- <usps-home></usps-home> -->
    </main>
</template>

<script>
export default {
    props: {
        status: Number,
    },
    computed: {
        title() {
            return {
                503: 'Service Unavailable',
                500: 'Server Error',
                404: 'Pagina niet gevonden',
                403: 'Niet toegankelijk',
            }[this.status];
        },
        description() {
            return {
                503: 'Oven offline, binnenkort weer terug!.',
                500: 'Oeps daar ging iets mis :(, keer terug en probeer het opnieuw of neem contact met ons op.',
                404: 'Aii deze pagina bestaat niet (meer).',
                403: 'Geen toegang :(',
            }[this.status];
        },
    },
};
</script>
